import logo from './logo.svg';
import './App.css';
import RouterApp from './router';

function App() {
  return (
    <RouterApp />
  );
}

export default App;
